import { render, staticRenderFns } from "./HorizontalTableYear.vue?vue&type=template&id=8d5d0342&scoped=true&"
import script from "./HorizontalTableYear.vue?vue&type=script&lang=js&"
export * from "./HorizontalTableYear.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalTableYear.vue?vue&type=style&index=0&id=8d5d0342&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5d0342",
  null
  
)

export default component.exports